import axiosInstance from './axiosInstance';

const goalsService = {
  editGoal: async (goal) => {
    try {
      const response = await axiosInstance.post('/goals/edit', { goal });
      return response.data;
    } catch (error) {
      console.error('Error creating goal:', error.response?.data || error.message);
      throw error;
    }
  },
  getPreviousGoals: async (projectId) => {
    try {
      const response = await axiosInstance.post('/goals/previous-goals', {project_id: projectId});
      return response.data.goals;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
  updateGoal: async (fields) => {
    try {
      const response = await axiosInstance.post('/goals/update-goal', fields);
      return response.data.goals;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
  performGoal: async (goalId) => {
    try {
      const response = await axiosInstance.post('/goals/perform-goal', {goal_id: goalId});
      return response.data.questions;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
  addTaskToGoal: async (fields) => {
    try {
      const response = await axiosInstance.post('/goals/add-task', fields);
      return response.data;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default goalsService;
